import { getAllFeedback, getAllReviews } from '@services/api/feedback/feedbackServices';
import { useQuery } from '@tanstack/react-query';
import { RatingsData, Review, ReviewsProps } from 'types/feedback/feedbackTypes';


export const useFeedback=(id:string)=>{
    const {data,isLoading,error}=useQuery<RatingsData,Error>({
            queryKey:['feedback'],
            queryFn:()=>getAllFeedback(id),
            refetchOnWindowFocus: false
    });
    return{
        data:data,
        isLoading,
        error
    }
}
export const useReviews=(id:string)=>{
    const {data,isLoading,error}=useQuery<Review[],Error>({
            queryKey:['reviews'],
            queryFn:()=>getAllReviews(id),
            refetchOnWindowFocus: false
    });
    return{
        data:data,
        isLoading,
        error
    }
}